import React, {useRef} from 'react';
import {useGridKeyboard} from '@hooks/keyboard';

interface KeyboardGridProps {
    children: React.ReactNode;
    rowSelector: string;
    cellSelector?: string;
    className?: string;
    tabbable?: boolean;
}

export const KeyboardGrid: React.FC<KeyboardGridProps> = ({
    children,
    rowSelector,
    cellSelector,
    className,
    tabbable = false
}) => {
    const ref = useRef<HTMLDivElement>(null);

    useGridKeyboard(ref, {rowSelector, cellSelector});

    return (
        <div ref={ref} className={className} data-keyboard-grid tabIndex={tabbable ? 0 : undefined}>
            {children}
        </div>
    );
};
